import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { vrefiyUpi } from "../../api";


/**
 * ReConfirmupiDetails component asks the user to confirm UPI details before submission.
 * Handles verification, loading state, and navigation based on API response.
 */
const ReConfirmupiDetails = ({ login = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { userId } = useParams();
  const upidetail = location.state?.uservalue || {};

  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const handleYesClick = () => {
    setIsLoading(true);
    let formData = new FormData()
    formData.append('upi_id', upidetail.upi_id)
    formData.append('name', 'xyz')
    formData.append('iirpl_sap_code', userId)
    vrefiyUpi(formData).then((data) => {

      if (data?.data?.accountExists === "YES") {
        navigate(`/${redirectUrl}/add-upi-details`, {
          state: {
            gpaydetails: data?.data,
            id: upidetail.upi_id,
            userId: userId,
          },
        });
      } else {
        navigate(`/${redirectUrl}/wrong-upi-details`, {
          state: { gpaydetails: upidetail.upi_id, userId: userId },
        });
        // Handle error scenario as needed
      }
    }).catch(error => {
      // Handle API call error
      alert("API call error", error);
    }).finally(() => {
      //setIsLoading(false); // Set loading to false after API call
    });

  };


  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-6 mt-10 pancard-data">
            <div className="text-center mb-7">
              <img
                width="300"
                alt="icon"
                src={toAbsoluteUrl("/media/images/reconfirm-img.png")}
              />
            </div>
          </div>

          <div className="col-md-6 mt-10 pancard-data">
            <div className="mt-15">
              <h1 className="mb-5">Re-Confirm</h1>
              <p>Please make sure you have checked all your details.</p>
              <p>UPI ID :  {upidetail.upi_id}</p>
              <div className="btns cn-btn mt-15 d-flex">
                <button
                  className="btn bgdark-blue text-white"
                  onClick={() => navigate(-1)}
                >
                  No
                </button>
                <button
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: isLoading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: isLoading ? "not-allowed" : "pointer",
                  }}
                  onClick={handleYesClick}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReConfirmupiDetails